import { useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";
import { clearMetaTags } from "./use-meta-tag";


const MetaResetHandler = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    clearMetaTags();
  }, [location.pathname]);

  return null;
};

export default MetaResetHandler;
